import sciQuiz from './sciQuiz';
import triviaQuiz from './triviaQuiz';
import oopQuiz from './oopQuiz';

const comboQuiz = [...oopQuiz, ...sciQuiz, ...triviaQuiz];

export default comboQuiz;
